import { APP_ROUTES } from "@/constants/app-routes";
import { LocalStorageKeys } from "@/constants/local-storage-keys";
import { markExplicitLogout } from "@/utils/auth/logout-telemetry";
import { hasSignedInBefore as readHasSignedInBefore } from "@/utils/has-signed-in-before";
import { resetMixpanel } from "@/utils/mixpanel";
import { useClerk } from "@clerk/clerk-react";
import { useQueryClient } from "@tanstack/react-query";

export const useLogout = () => {
  const queryClient = useQueryClient();
  const { signOut } = useClerk();

  const logout = async () => {
    try {
      // Tag this as user-initiated so the guard's follow-on sign-out isn't
      // reported as an involuntary/mysterious logout.
      markExplicitLogout();
      await signOut({
        redirectUrl: readHasSignedInBefore() ? APP_ROUTES.LOGIN : APP_ROUTES.REGISTER,
      });
      queryClient.clear();
      resetMixpanel();

      const hasSignedInBefore = localStorage.getItem(LocalStorageKeys.HAS_SIGNED_IN_BEFORE_KEY);
      localStorage.clear();

      if (hasSignedInBefore) {
        localStorage.setItem(LocalStorageKeys.HAS_SIGNED_IN_BEFORE_KEY, hasSignedInBefore);
      }

      console.log("Signed out from Clerk");
    } catch (error) {
      console.error("Error signing out from Clerk:", error);
      throw error;
    }
  };

  return { logout };
};
